import React from 'react';
import usePostForm from '../../hooks/usePostForm';
import Header from './Header';
import { 
  BasicInfoSection, 
  ContentSection, 
  MediaSection, 
  FormButtons 
} from '../../components/admin/PostFormSections';
import './PostForm.css';
import './Header.css';

const PostForm = () => {
  const {
    post,
    loading,
    images,
    id,
    handleSubmit,
    handleImagesChange, 
    handleLogout,
    handleContentChange,
    handleBackToDashboard,
    handleInputChange
  } = usePostForm();

  return (
    <div className="post-form-container">
      <Header 
        title={id ? 'Edit Post' : 'Create New Post'} 
        onLogout={handleLogout}
        onCreatePost={null}
        showBackButton={true}
        onBackClick={handleBackToDashboard}
      />

      <div className="main-content">
        {loading && <div className="loading-indicator">Loading...</div>}

        <form onSubmit={handleSubmit} className="post-form">
          <BasicInfoSection 
            post={post} 
            handleInputChange={handleInputChange} 
          />
          
          <ContentSection 
            content={post.content} 
            handleContentChange={handleContentChange} 
          />
          
          <MediaSection 
            images={images}
            onImagesChange={handleImagesChange}
          />
          
          <FormButtons 
            loading={loading} 
            onCancel={handleBackToDashboard} 
            onSubmit={handleSubmit}
          />
        </form>
      </div>
    </div>
  );
};

export default PostForm;
